import { z } from 'zod';

// The settings schemas are the exact record of a stored settings doc: they
// assert, they never transform. An address is formatted (lowercase, no spaces)
// by every writer BEFORE validation — see
// formatOrganizationSettingsGroupValues — so here it must already be
// lowercase. 320 = RFC address max.
export const settingsEmailSchema = z
  .string()
  .max(320)
  .check(z.email())
  .refine((email) => email === email.toLowerCase(), 'must be lowercase');

/**
 * A list that may not repeat itself, reported the way the settings editor
 * shows it. `identity` names what makes two entries the same when it is not
 * the entry itself.
 */
export const requiresUnique = <T>(
  field: string,
  identity: (item: T) => unknown = (item) => item,
) =>
  [
    (items: T[]) => new Set(items.map(identity)).size === items.length,
    `${field} must not contain duplicates`,
  ] as const;
